<template>
 

  <div class="container put-right" style="direction:rtl">

      <h3 class="heading" style="display:initial;margin-left:2rem">المتهمين</h3>
       


<div class="container menu">
<div class="table-responsive">
<table class="table">
  <thead>
    <tr>
      <th scope="col"> الترتيب</th>
      <th scope="col"> اسم المتهم</th>
    <!--  <th scope="col"> نوع البلاغ  </th> -->
      <th scope="col"> رقم المتهم  </th>
     
    </tr>
  </thead>
  <tbody>
    
    <tr v-for="keey in formdata2" :key="keey.id" >
      
      <th scope="row" >{{keey.id}}</th>
      <td>       {{keey.name}} </td>
    <!--  <td>{{keey.complaint_type}}</td> -->
      <td>{{keey.phone_1}}</td>
     
    
    </tr>
   
  </tbody>
</table>
</div>
  
</div>
</div>


           


   

</template>

<script>
import  geturl  from "@/comp/geturl";

export default {
name:"AccusedView",
props:['id'],
data(){
  return{
     formdata2:[], 
  }
},
mounted() {
  
 
    
       fetch(geturl()+"complaints/accused_and_victim/", {
      
      headers: {"Content-Type": "application/json"},
      })
      .then(res => res.json())
      .then(data => {this.formdata2 = data 
        console.log(data)
        this.formdata2 = this.formdata2.filter((e)=>{
          return e.complaint == this.id
        })   

      })


      

      
    }
}
</script>

<style>

</style>